import { Box, Button, styled } from "@mui/material";

export const StyledNavButton = styled(Button)({
  borderRadius: "32px",
});

export const StyledParentWrapper = styled(Box)({
  padding: "40px 24px",
  backgroundColor: "#fff",
  borderRadius: "16px",
  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
});
